var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "ct-offcanvas-panel map-add-feature-panel",
      style: { "margin-bottom": _vm.panelBottom },
    },
    [
      !_vm.isActionNewOccurrence
        ? _c(
            "button",
            {
              staticClass:
                "btn btn-rounded btn-responsive btn-lg btn-tertiary-main btn-add-feature",
              attrs: { type: "button", disabled: _vm.isActionNewOccurrence },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onAddFeature.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.txtAddTitleButton) + "\n    ")]
          )
        : _c(
            "button",
            {
              staticClass:
                "btn btn-rounded btn-responsive btn-lg btn-outline-grape-fruit btn-add-feature",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onCancelAddFeature.apply(null, arguments)
                },
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.txtCancelTitleButton) + "\n    ")]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }